/* eslint-disable linebreak-style */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
import { Sentry } from 'root/utils/raven';
import GraphemeSplitter from 'grapheme-splitter';
import isBrowser from 'utils/isBrowser';

const getConfig = require('next/config').default;

const splitter = new GraphemeSplitter();

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const InsertAdUnit = ({ htmlInReact = [], isPhone = false, width = false }) => {
  const desktopChar = 1600;
  let mobileChar = 750;
  const height = isBrowser() ? window.innerHeight : false;
  Sentry.addBreadcrumb({
    category: 'utils/InsertAdUnit',
    message: 'Insert ads on HTML',
    level: Sentry.Severity.Debug,
  });
  const adsDensity = Number.isNaN(+publicRuntimeConfig.ADS_DENSITY) ? 1 : +publicRuntimeConfig.ADS_DENSITY;

  let countChar = 0;
  const pixelByChar = 9.4;
  const pixelByLine = 25;
  if (width && height) {
    const sizeText = (height / 3) * 2;
    const textLines = sizeText / pixelByLine;
    mobileChar = (width / pixelByChar) * textLines;
  }

  /**
   * Count characters inside HTML elements
   * @param ctx
   */
  const onCountChar = (ctx) => {
    try {
      if (ctx?.props && ctx?.props?.children) {
        if (Array.isArray(ctx?.props?.children)) {
          for (const child of ctx?.props?.children) {
            if (typeof (child) === 'string') {
              countChar += splitter.countGraphemes(child) * adsDensity;
            }

            // Verify if the object is figure or image
            if (typeof (child) === 'object' && ['figure', 'img'].includes(child?.type)) {
              // Sum 350 char per image on article
              countChar += isPhone ? mobileChar / 2 : 350;
            } else if (typeof (child) === 'object') {
              onCountChar(child);
            }
          }
        } else {
          if (typeof (ctx?.props?.children) === 'string') {
            countChar += splitter.countGraphemes(ctx?.props?.children) * adsDensity;
          }

          // Verify if the object is figure or image
          if (typeof (ctx?.props?.children) === 'object' && ['figure', 'img'].includes(ctx?.props?.children?.type)) {
            // Sum 350 char per image on article
            countChar += isPhone ? mobileChar / 2 : 350;
          } else if (typeof (ctx?.props?.children) === 'object') {
            onCountChar(ctx?.props?.children);
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  /**
   * Insert ads on list elements
   * @param ctx
   */
  const addListAds = (ctx) => {
    const list = [];
    try {
      if (typeof (ctx) === 'object' && ctx.type === 'ul') {
        let ul = {
          type: 'ul',
          props: {
            children: [],
          }
        };
        const checkCtx = ctx?.props?.children;
        if (!Array.isArray(checkCtx)) {
          onCountChar(checkCtx);
          ul.props.children.push(checkCtx);
          list.push(ul);
          return list;
        }
        ctx?.props?.children?.forEach((child) => {
          onCountChar(child);
          ul.props.children.push(child);
          if (isPhone && (countChar >= mobileChar || countChar >= mobileChar * 0.9)) {
            const ads = {
              type: 'ads',
              props: {
                children: []
              }
            };

            list.push(ul);
            list.push(ads);
            ul = {
              type: 'ul',
              props: {
                children: [],
              }
            };
            countChar = 0;
          } else if (countChar >= desktopChar || countChar >= desktopChar * 0.9) {
            const ads = {
              type: 'ads',
              props: {
                children: []
              }
            };

            list.push(ul);
            list.push(ads);
            ul = {
              type: 'ul',
              props: {
                children: [],
              }
            };
            countChar = 0;
          }
        });
        if (ul.props.children.length > 0) {
          list.push(ul);
        }
      }
      return list;
    } catch (error) {
      Sentry.captureException(error);
      return list;
    }
  };

  /**
   * Insert ads on HTML
   * @returns {[]}
   */
  const addAds = () => {
    const contentHTML = [];
    try {
      if (htmlInReact.length) {
        // eslint-disable-next-line no-plusplus
        for (let index = 0; index < htmlInReact.length; index++) {
          let ctx = htmlInReact[index];
          // Avoid process empty lines on HTML
          if (ctx !== '\n') {
            if (typeof (ctx) === 'object' && !['ul', 'figure', 'img'].includes(ctx.type)) {
              onCountChar(ctx);
            }

            if (typeof (ctx) === 'string') {
              onCountChar(ctx);
            }

            // Verify if the object is figure or image
            if (typeof (ctx) === 'object' && ['figure', 'img'].includes(ctx.type)) {
              // Sum 350 char per image on article
              countChar += isPhone ? mobileChar / 2 : 350;
            }

            // Count characters on list elements
            // TODO: Add `ol` elements
            if (typeof (ctx) === 'object' && ['ul'].includes(ctx.type)) {
              htmlInReact.splice(index, 1);
              ctx = addListAds(ctx);
            }

            // Add HTLM element on new array
            if (Array.isArray(ctx)) {
              ctx.forEach((el) => {
                contentHTML.push(el);
              });
            } else {
              contentHTML.push(ctx);
            }

            // Create ads element to replace on render component
            const ads = {
              type: 'ads',
              props: {
                children: []
              }
            };

            if (!isPhone) {
              // Verify if the countChar between max and min
              if (countChar >= desktopChar || countChar >= desktopChar * 0.9) {
                contentHTML.push(ads);
                countChar = 0;
              }
            } else if (countChar >= mobileChar || countChar >= mobileChar * 0.9) {
              contentHTML.push(ads);
              countChar = 0;
            }
          } else {
            contentHTML.push(ctx);
          }
        }
      }
    } catch (error) {
      Sentry.captureException(error);
    }
    return contentHTML;
  };

  return addAds();
};

export default InsertAdUnit;
